/**
 * Server Fleet Constants
 * 
 * IMPORTANT: These values must match the server-side constants in:
 * game-server/modules/ponder-flight-game/fleets.go
 * 
 * If server values change, update this file to match.
 */

// Number of independent cabin-configuration slots per fleet.
// Slots carry no grouping: any slot may hold any unlocked model, and the same
// model may occupy several slots with different cabins.
export const FLEET_SLOT_COUNT = 10;

// Maximum length of the player-authored slot label (in code points).
// Kept short because the label is the primary text in several narrow places.
export const FLEET_SLOT_NAME_MAX_LENGTH = 12;

// Class constants for indexing seats and comfort arrays
export const SeatClassIndex = {
  ECON: 0,
  BUSINESS: 1,
  FIRST: 2,
} as const;

// Seat space equivalencies (relative to economy seats)
// MaxSeats represents the maximum economy seats; other classes take more space
export const BusinessSeatEquivalent = 2.5; // 1 business seat = 2.5 econ seats
export const FirstSeatEquivalent = 5; // 1 first class seat = 5 econ seats

/**
 * Calculate econ-equivalent seats for a seat configuration
 * Mirrors server's CalculateEconEquivalentSeats function
 */
export function calculateEconEquivalentSeats(
  econSeats: number,
  businessSeats: number,
  firstSeats: number
): number {
  return (
    econSeats +
    businessSeats * BusinessSeatEquivalent +
    firstSeats * FirstSeatEquivalent
  );
}

// Fleet diversity penalty: maintenance cost multiplied by (1 + (families - 1) / FLEET_DIVERSITY_DIVISOR),
// counting aircraft families, so one family costs nothing more (fleetDiversityMultiplier).
export const FLEET_DIVERSITY_DIVISOR = 10;

// Fleet maintenance rate: annual rate = MAINTENANCE_BASE_RATE + MAINTENANCE_AGE_INCREMENT × ageInYears
export const MAINTENANCE_BASE_RATE = 0.015;
export const MAINTENANCE_AGE_INCREMENT = 0.0025;
